import DropdownTemplateView from "../../DropdownTemplateView"
import TypeOfWorkSelector from "../../typesOfWork/TypeOfWorkSelector"
import $ from 'jquery'

export class TypeOfWorkMenu extends DropdownTemplateView {

    constructor({
        additionalClass = '',
        showMenuCb = () => {},
        hideMenuCb = () => {},
    }) {
        super()

        this.params = {
            additionalClass,
            showMenuCb,
            hideMenuCb,
        }
    }

    templateHtml() {
        return "<div class='dropdownContainer components_typeOfWorkMenu <%=additionalClass%>'></div>"
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass
        }
    }

    afterRender() {
        this.typeOfWorkSelector = new TypeOfWorkSelector({
            onTypeSelected: (id) => {
                this._selectTypeOfWork(id)
            },
            onlyActive: true,
        }).init(this.$el)

        this.getEl().on('click', e => e.stopPropagation())
    }

    update() {
        this.typeOfWorkSelector.update()
    }

    showAt($element, positionParams, callback) {
        super.showAt($element, positionParams);
        this.update();
        this.callback = callback;
    }

    onHide() {
        super.onHide();
        this.callback(this.selectedTypeId);
        this.params.hideMenuCb()
    }

    onShow() {
        super.onShow()
        this.params.showMenuCb()
    }

    setTypeOfWorkId(id) {
        this.selectedTypeId = id
        this.typeOfWorkSelector.setState({
            selectedTypeId: id
        })
    }

    _selectTypeOfWork(id) {
        this.setTypeOfWorkId(id)
        this.hide()
    }

    mouseDownTargetElement() {
        return $('body')
    }
}



// WEBPACK FOOTER //
// ./web/js/controls/task/TypeOfWorkMenu.js